import { useCallback, useState, useEffect } from 'react';
import { useAuth0 } from '@auth0/auth0-react';

export const useFetchAssets = (groupId, showAddModal) => {
    const [assets, setAssets] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const { getAccessTokenSilently } = useAuth0();
    const apiUrl = process.env.REACT_APP_API_URL;
    
    const fetchAssets = useCallback(async () => {
        setLoading(true);
        setError(null);

        try {
            const token = await getAccessTokenSilently({
                authorizationParams: {
                    audience: process.env.REACT_APP_API_AUDIENCE,
                }
            });
            const response = await fetch(`${apiUrl}/api/assets`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });

            if (!response.ok) {
                throw new Error(`Unable to load marketplace assets (${response.status})`);
            }

            const data = await response.json();

            setAssets(Array.isArray(data) ? data : []);
        } catch (error) {
            console.error('Error fetching assets:', error);
            setError('Could not load marketplace listings. Please retry.');
            setAssets([]);
        } finally {
            setLoading(false);
        }
    }, [apiUrl, getAccessTokenSilently]);

    useEffect(() => {
        fetchAssets();
    }, [fetchAssets, groupId, showAddModal]);

    return { assets, loading, error, refetch: fetchAssets };
};

export default useFetchAssets;
